import { z } from 'zod';
import {
  OptionsSchema as BaseOptionsSchema,
  AuiTokenSchema,
  TriggerUnionSchema,
  TriggerOptionSchema,
} from '../../WidgetVariant';

const SupportWindowHeaderSchema = z.union([
  z.object({
    alt: z.never().optional(),
    src: z.never().optional(),
    text: z.string(),
  }),
  z.object({
    alt: z.string().optional(),
    src: z.string(),
    text: z.never().optional(),
  }),
]);

const TopicSchema = z.object({
  auiIcon: z.string().optional(),
  text: z.string(),
  opensLandingPanel: z.boolean().optional(),
  href: z.string().url().optional(),
  value: z.string().optional(),
});

const DisplayModesSchema = z.enum(['FAB', 'FIC', 'WINDOW', 'HIDDEN']);
export type DisplayModes = z.infer<typeof DisplayModesSchema>;
export const ShowActionDisplayModeSchema = DisplayModesSchema.exclude(['HIDDEN']);
export type ShowActionDisplayModes = z.infer<typeof ShowActionDisplayModeSchema>;

const PositionAnchorSchema = z.enum(['left', 'right', 'center']);

const PositionRuleSchema = z.object({
  anchorX: PositionAnchorSchema.optional(),
  offsetXpx: z.number().optional(),
  offsetYpx: z.number().optional(),
});

const PositionSchema = z.record(z.string(), PositionRuleSchema);

const FloatingInputCardBaseSchema = z.object({
  callbackConfirmationImg: z
    .object({
      alt: z.string().optional(),
      src: z.string(),
    })
    .optional(),
  chatLogo: z
    .object({
      alt: z.string().optional(),
      src: z.string(),
    })
    .optional(),
  initialDisplayMode: DisplayModesSchema.optional(),
  inputFicInputPlaceHolderText: z.string().optional(),
  position: PositionSchema.optional(),
  supportWindowHeader: SupportWindowHeaderSchema.optional(),
  size: z.enum(['small', 'medium', 'large']).optional(),
  topics: z.array(TopicSchema).optional(),
  fabNotificationIndicatorColor: z.string().optional(),
  logo: z.object({
    alt: z.string().optional(),
    src: z.string(),
    lottieUrl: z.string().optional(),
  }),
});

const FloatingInputCardSchema = FloatingInputCardBaseSchema.merge(AuiTokenSchema).merge(TriggerOptionSchema.partial());

export const OptionsSchema = BaseOptionsSchema.extend({
  'floating-input-card': TriggerUnionSchema.and(FloatingInputCardSchema),
});

export const PartialOptionsSchema = BaseOptionsSchema.extend({
  'floating-input-card': TriggerUnionSchema.and(FloatingInputCardSchema.partial()),
}).partial();

export type Topic = z.infer<typeof TopicSchema>;
export type Options = z.infer<typeof OptionsSchema>;
export type PartialOptions = z.infer<typeof PartialOptionsSchema>;
